import React, { useEffect } from 'react';
import SubscriptionStatus from '../subscription/SubscriptionStatus';
import TeamLicenseUsageSummary from './TeamLicenseUsageSummary';

const LicensingSettings = ({ team, teamStats }) => {
  // Log the props for debugging
  useEffect(() => {
    console.log('LicensingSettings - team:', team);
    console.log('LicensingSettings - teamStats:', teamStats);
  }, [team, teamStats]);
  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4">License Usage</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
          View your current license usage and manage your subscription plan.
        </p>
        
        {/* License Usage Summary */}
        <div className="mb-6">
          <TeamLicenseUsageSummary
            activeMembers={teamStats.activeMembers}
            pendingInvitations={teamStats.pendingInvitations}
            planLimit={teamStats.planUserLimit}
          />
        </div>
        
        {/* License Details */}
        <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-md mb-6">
          <h3 className="text-md font-medium text-gray-900 dark:text-white mb-2">License Details</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">Current Plan</p>
              <p className="font-medium">{team.plan ? team.plan.charAt(0).toUpperCase() + team.plan.slice(1) : 'Free'}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">License Limit</p>
              <p className="font-medium">{teamStats.planUserLimit} users</p>
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">Active Members</p>
              <p className="font-medium">{teamStats.activeMembers} users</p>
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">Pending Invitations</p>
              <p className="font-medium">{teamStats.pendingInvitations} invitations</p>
            </div>
          </div>
        </div>
        
        {/* Important Notes */}
        <div className="bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-400 p-4 rounded-md mb-6">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-blue-700 dark:text-blue-300">
                <strong>Important:</strong> Both active team members and pending invitations count toward your license limit.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Subscription Management */}
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Subscription Management</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
          View and manage your current subscription plan.
        </p>
        
        <SubscriptionStatus />
      </div>
    </div>
  );
};

export default LicensingSettings;
